import axios from "axios";
import salsify from 'salsify-experiences-sdk';

export default (function () {
    const styles = [].slice.apply(document.getElementsByClassName('product-details__style-button'));
	const sizeGroups = [].slice.apply(document.getElementsByClassName('size-group'));
	const sizeButtons = [].slice.apply(document.getElementsByClassName('product-details__size-button'));
	const primaryImage = document.getElementsByClassName('product-details__product-image--primary')[0];
	const loading = document.getElementsByClassName('loading-show')[0];
	const previewImage = document.getElementsByClassName('product-details__preview-images--primary')[0];
    const buyButtons = [].slice.apply(document.getElementsByClassName('product-details__cart-btn'));
    const buyButtonDirectComms = [].slice.apply(document.getElementsByClassName('product-details__cart-btn-directComm'));
    const priceHeader = document.getElementsByClassName('product-details__price')[0];
    const originalPriceHeader = document.getElementsByClassName('product-details__original_price')[0];
    const upcHeader = document.getElementsByClassName('product-details__upc')[0];
    const itemCodeHeader = document.getElementsByClassName('product-details__item-code')[0];
    const itemCodeHeader2 = document.getElementsByClassName('product-details__item-code2')[0];
	const productQuantity = document.getElementsByClassName('product-details__quantity-select')[0];
    const prodUPC = document.getElementById('prodUPC');
    const addToCartBox = document.getElementsByClassName('product-details__option product-details__purchase-option-online')[0];
    const restrictedItemPrice = document.getElementsByClassName('restricted-item-price-section')[0];
    const showConsumerPrice = document.getElementsByClassName('show-consumer-price')[0];
    const showConsumerSalePrice = document.getElementsByClassName('show-consumer-sale-price')[0];
    const showConsumerSaleMessage = document.getElementsByClassName('product-details__sale_message')[0];
    const outOfStock = document.getElementsByClassName('out-of-stock')[0];
    const personalizationColor = document.getElementById('personalizationColor');
    const personalizedText = document.getElementById('personalizedText');
    const maxCharLimit = document.getElementById('max-pers-char-limit');

    styles.forEach((item, index) => {

		item.addEventListener('click', e => {
			e.preventDefault();

			styles.forEach((item, i) => {
                item.classList.remove('product-details__style-button--active');
			});

            if (e.currentTarget.classList.contains('product-details__style-button')) {
				const self = e.currentTarget;

                self.classList.add('product-details__style-button--active');

				SizeGroupDisplay(self.dataset.colorcode);
			}
        });

	});

    sizeButtons.forEach((item, index) => {

		item.addEventListener('click', e => {
			e.preventDefault();
			const self = e.currentTarget;

			sizeButtons.forEach((item, i) => {
				item.classList.remove('product-details__size-button--active');
			});

            self.classList.add('product-details__size-button--active');

			if (typeof window.coastal.getpriceurl !== "undefined") {
				loading.classList.add('loading-show');

				axios.post(window.coastal.getpriceurl, { ItemNumber: self.dataset.itemnumber })
                    .then((response) => {
                        //console.log(response);

						self.dataset.price = response.data;

						prodUPC.value = self.dataset.upc;

                        if (buyButtons.length !== 0) {
                            buyButtons.forEach(function (buyButton) {
                                buyButton.setAttribute('data-name', self.dataset.name);
                                buyButton.setAttribute('data-upc', self.dataset.upc);
                                buyButton.setAttribute('data-imagepath', self.dataset.imagepath);
                                buyButton.setAttribute('data-price', self.dataset.price);
                                buyButton.setAttribute('data-itemnumber', self.dataset.itemnumber);
                                buyButton.setAttribute('data-maxperschars', self.dataset.maxperschars)
                            });
                        }
                        if (buyButtonDirectComms.length !== 0) {
                            buyButtonDirectComms.forEach(function (buyButton) {
                                buyButton.setAttribute('data-itemnumber', self.dataset.itemnumber);
                            });
                        }

                        if (directCommPricing === true) {
                            UpdatePriceDirectComm(self.dataset.itemnumber.replace(/  +/g, ' '));
                        } else {
                            UpdatePrice(self.dataset.price);
                        }
                        UpdateItemCode(self.dataset.itemnumber);
                        UpdateUPC(self.dataset.upc);
                        if (self.dataset.maxperschars !== "") {
                            UpdateMaxChars(self.dataset.maxperschars)
                        }
                        //For Salsify Enhanced Content generation in Product-Details.cshtml
                        const productID = self.dataset.upc;
                        document.querySelector('#enhanced-content-container').innerHTML = '';
                        if (salsify.enhancedContent.exists(productID)) {
                            salsify.enhancedContent.renderIframe(document.querySelector('#enhanced-content-container'), productID)
                        }
                        SwitchImages(self.dataset.imagepath);

                        // Update data-rs-item-id and rsItemId
                        const rsContainer = document.getElementById('rsProductOfferContainer');
                        const rsForm = document.querySelector('#rsAddToCartForm form');
                        const selectedItemId = self.dataset.itemnumber.replace(/  +/g, ' ');
                        rsContainer.dataset.rsItemId = selectedItemId;
                        if (rsForm) {
                            const rsItemIdInput = rsForm.querySelector('input[name="rsItemId"]');
                            if (rsItemIdInput) {
                                rsItemIdInput.value = selectedItemId;
                            }
                        }
                    })
					.catch((error) => {
						loading.classList.remove('loading-show');
                        console.log(error);
                    });
            }
        });

    });
    if (buyButtonDirectComms.length !== 0) {
        buyButtonDirectComms[0].addEventListener("click", function () {
            var buyButton = buyButtonDirectComms[0];
            document.querySelector('#status-message').innerHTML = '';
            document.querySelector('#error-message').innerHTML = '';
            const rsContainer = document.getElementById('rsProductOfferContainer');
            if (!rsContainer) {
                document.querySelector('#error-message').innerHTML = "Product data not found.";
                return;
            }
            if (personalizationColor !== null && personalizedText !== null && (personalizationColor.value === "" || personalizedText.value === "")) {
                document.querySelector('#error-message').innerHTML = "Please ensure thread color and/or personalization text are filled out.";
                return;
            }

            const rsForm = rsContainer.querySelector('#rsAddToCartForm form');
            if (!rsForm) {
                document.querySelector('#error-message').innerHTML = "Mini-cart form not found.";
                console.error("Static RS form not found in rsProductOfferContainer");
                return;
            }

            // Update form inputs
            const formInputs = rsForm.querySelectorAll('input');
            const selectedQuantity = buyButton.getAttribute("data-quantity") || "1";
            formInputs.forEach(input => {
                // Enable personalization inputs before updating
                if (input.name.startsWith('rsProductPersonalization')) {
                    input.disabled = false;
                }

                // Update related items (if input exists)
                if (input.name === 'rsRelatedItemSkus') input.value = rsContainer.dataset.rsRelatedItems || '';

                // Update quantity for select element
                if (input.name === 'quantity') input.value = selectedQuantity;

                // Update personalization fields if personalizationColor and personalizedText are defined
                if (personalizationColor !== null && personalizedText !== null) {
                    if (input.name === 'rsProductPersonalizationLabel1') input.value = 'Personalization Color';
                    if (input.name === 'rsProductPersonalizationValue1') input.value = personalizationColor.value;
                    if (input.name === 'rsProductPersonalizationLabel2') input.value = 'Font';
                    if (input.name === 'rsProductPersonalizationValue2') input.value = 'BLOCK';
                    if (input.name === 'rsProductPersonalizationLabel3') input.value = 'Text';
                    if (input.name === 'rsProductPersonalizationValue3') input.value = personalizedText.value;
                }
            });

            // Update rsItemQtySelect
            const quantitySelect = rsForm.querySelector('select[name="quantity"]');
            if (quantitySelect) {
                quantitySelect.value = selectedQuantity;
            }

            // Update cart count and modal with dynamic cart ID
            _rsProductApiClient.getItem(rsContainer.dataset.rsItemId.replace(/  +/g, ' '),
                function (productData, context) {
                    // Update form action with dynamic cart ID
                    const cartId = productData.cart?.id || Math.floor(1000 + Math.random() * 9000);
                    rsForm.action = `https://shop.coastalpet.com/cart--${cartId}`;

                    // Submit form to add item and trigger modal
                    const submitEvent = new Event('submit', { bubbles: true });
                    rsForm.dispatchEvent(submitEvent);

                    // Update cart count
                    document.querySelectorAll('.rsCartCount').forEach(function (c) {
                        c.innerHTML = productData.cart?.count || buyButton.getAttribute("data-quantity") || "1";
                    });
                    document.querySelector('#status-message').innerHTML = "Added item to cart.";

                    // Fallback: Populate modal with basic data if RS fails
                    const modalWrapper = document.querySelector('.rsMiniCartModalWrapper');
                    if (modalWrapper && modalWrapper.classList.contains('rsHidden')) {
                        modalWrapper.classList.remove('rsHidden');
                        const modal = modalWrapper.querySelector('.rsModal');
                        if (modal) {
                            modal.querySelector('.rsProductTitle').innerHTML = buyButton.dataset.name || "Item";
                            modal.querySelector('.rsProductImage').src = buyButton.dataset.imagepath || "";
                            modal.querySelector('.rsPrice').innerHTML = buyButton.dataset.price || "";
                            modal.querySelector('.rsCartCount').innerHTML = productData.cart?.count || buyButton.getAttribute("data-quantity") || "1";
                            modal.querySelector('.rsViewCartButton').setAttribute('href', `https://shop.coastalpet.com/cart--${cartId}`);
                        }
                    }
                },
                function (error, context) {
                    document.querySelector('#error-message').innerHTML = "Failed to fetch item data.";
                    console.error(error);

                    // Fallback: Show modal with minimal data
                    const cartId = Math.floor(1000 + Math.random() * 9000);
                    rsForm.action = `https://shop.coastalpet.com/cart--${cartId}`;
                    const submitEvent = new Event('submit', { bubbles: true });
                    rsForm.dispatchEvent(submitEvent);

                    const modalWrapper = document.querySelector('.rsMiniCartModalWrapper');
                    if (modalWrapper) {
                        modalWrapper.classList.remove('rsHidden');
                        const modal = modalWrapper.querySelector('.rsModal');
                        if (modal) {
                            modal.querySelector('.rsProductTitle').innerHTML = buyButton.dataset.name || "Item";
                            modal.querySelector('.rsProductImage').src = buyButton.dataset.imagepath || "";
                            modal.querySelector('.rsPrice').innerHTML = buyButton.dataset.price || "";
                            modal.querySelector('.rsCartCount').innerHTML = buyButton.getAttribute("data-quantity") || "1";
                            modal.querySelector('.rsViewCartButton').setAttribute('href', `https://shop.coastalpet.com/cart--${cartId}`);
                        }
                    }
                }
            );

            salsify.events.addToCart({
                productIdType: 'SKUWITHCHECKDIGIT',
                productId: upcHeader.innerHTML,
                quantity: buyButton.getAttribute("data-quantity"),
                price: buyButton.dataset.price || priceHeader.innerHTML
            });
        });
    }
    if (typeof productQuantity !== "undefined" && productQuantity !== null) {
        productQuantity.addEventListener('change', e => {
            UpdateQuantity();
        });
    }

    function UpdateQuantity() {
        if (buyButtons.length !== 0) {
            if (typeof productQuantity !== "undefined" && productQuantity !== null) {
                buyButtons.forEach(function (buyButton) {
                    buyButton.setAttribute('data-quantity', productQuantity.options[productQuantity.selectedIndex].value);
                });
            }
        }
        if (buyButtonDirectComms.length !== 0) {
            if (typeof productQuantity !== "undefined" && productQuantity !== null) {
                buyButtonDirectComms.forEach(function (buyButton) {
                    buyButton.setAttribute('data-quantity', productQuantity.options[productQuantity.selectedIndex].value);
                });
            }
        }
    }

    function SwitchImages(imageSrc) {
		primaryImage.setAttribute('src', imageSrc);
		previewImage.setAttribute('src', imageSrc);

		loading.classList.remove('loading-show');
	}

	function SizeGroupDisplay(colorcode) {
		//console.log(colorcode);

		sizeGroups.forEach((item, i) => {
			item.classList.remove('size-group--active');
		});

		const activeSizeGroup = sizeGroups.find(obj => {
			return obj.dataset.sizegroup === colorcode;
		});

        activeSizeGroup.classList.add('size-group--active');
        let groupSizeButtons = activeSizeGroup.getElementsByClassName('product-details__size-button');
        
        if (typeof groupSizeButtons[0] !== "undefined") {
            groupSizeButtons[0].click();
        }
    }
    function UpdatePriceDirectComm(itemCode) {
        const selectedProd = productList.find(product => {
            return product.context.itemId === itemCode;
        });
        if (selectedProd == null) {
            setTimeout(function () { UpdatePriceDirectComm(itemCode) }, 500);
        }
        else {
            if (selectedProd.prices == undefined) {
                showConsumerSalePrice.style.display = 'none';
                showConsumerPrice.style.display = 'none';
                priceHeader.textContent = restrictedItemPrice.style.display = 'block';
                addToCartBox.style.display = 'none';
            }
            else if (selectedProd.inventory.inStock == false) {
                showConsumerSalePrice.style.display = 'none';
                showConsumerPrice.style.display = 'none';
                priceHeader.textContent = outOfStock.style.display = 'block';
                addToCartBox.style.display = 'none';
            }
            else if (selectedProd.prices.reference.price !== null || selectedProd.prices.reference.message !== null) {
                showConsumerSalePrice.style.display = 'block';
                originalPriceHeader.textContent = "$" + selectedProd.prices.list;
                showConsumerPrice.style.display = 'block';
                priceHeader.textContent = "$" + selectedProd.prices.sell;
                showConsumerSaleMessage.textContent = selectedProd.prices.reference.message;
                restrictedItemPrice.style.display = 'none';
                outOfStock.style.display = 'none';
                addToCartBox.style.display = 'inline-flex';
            }
            else {
                showConsumerSalePrice.style.display = 'none';
                showConsumerPrice.style.display = 'block';
                priceHeader.textContent = "$" + selectedProd.prices.sell;
                restrictedItemPrice.style.display = 'none';
                outOfStock.style.display = 'none';
                addToCartBox.style.display = 'inline-flex';
                }
        }
    }
    function UpdatePrice(price) {
        priceHeader.textContent = price;
    }

    function UpdateUPC(upc) {
        upcHeader.textContent = upc;
    }

    function UpdateItemCode(itemCode) {
        itemCodeHeader.textContent = itemCode;
        itemCodeHeader2.textContent = itemCode;
    }

    function UpdateMaxChars(maxChars) {
        maxCharLimit.textContent = maxChars;
    }

    if (typeof styles[0] !== "undefined") {
        styles[0].click();
    }

    if (typeof sizeButtons[0] !== "undefined") {
        sizeButtons[0].click();
    }

    UpdateQuantity();

})();